/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */

import './LinkedBankAccountSummary.scss';

import noop from 'lodash/noop';
import React from 'react';
import { connect } from 'react-redux';
import { bool, func, array } from 'prop-types';
import LinkedBankAccountSummaryCard from 'components/layouts/Preferences/LinkedBankAccounts/LinkedBankAccountSummaryCard';
import {
  getLinkedAccountsOrderedByTypeName,
  showLinkedBankAccountSummary,
  showStopTransferBanner
} from 'state/linkedBankAccounts/LinkedBankAccountsSelectors';
import {
  hasAlaska529Only,
  hasMaryland529Only,
  hasNational529Only,
  isSalesforceRepEnabled
} from 'state/view/ViewSelectors';

const LinkedBankAccountSummary = ({
  isSalesforceRepEnabled,
  onClickReinitiateChallengeDeposits,
  onClickDelete,
  onClickUpdate,
  showLinkedBankAccountSummary,
  linkedAccountsOrderedByTypeName,
  showStopTransferBanner,
  hasAlaska529Only,
  hasMaryland529Only,
  hasNational529Only
}) =>
  showLinkedBankAccountSummary
    ? linkedAccountsOrderedByTypeName.map((bankAccount, i) => {
        return (
          <LinkedBankAccountSummaryCard
            bankAccount={bankAccount}
            key={i}
            index={i}
            isSalesforceRepEnabled={isSalesforceRepEnabled}
            hasAlaska529Only={hasAlaska529Only}
            hasMaryland529Only={hasMaryland529Only}
            hasNational529Only={hasNational529Only}
            onClickReinitiateChallengeDeposits={
              onClickReinitiateChallengeDeposits
            }
            onClickDelete={onClickDelete}
            onClickUpdate={onClickUpdate}
            showStopTransferBanner={showStopTransferBanner}
          />
        );
      })
    : null;

LinkedBankAccountSummary.propTypes = {
  onClickDelete: func.isRequired,
  linkedAccountsOrderedByTypeName: array.isRequired,
  showLinkedBankAccountSummary: bool
};

LinkedBankAccountSummary.defaultProps = {
  onClickDelete: noop,
  linkedAccountsOrderedByTypeName: [],
  showLinkedBankAccountSummary: false
};

const mapStateToProps = (state) => ({
  isSalesforceRepEnabled: isSalesforceRepEnabled(state),
  showLinkedBankAccountSummary: showLinkedBankAccountSummary(state),
  linkedAccountsOrderedByTypeName: getLinkedAccountsOrderedByTypeName(state),
  showStopTransferBanner: showStopTransferBanner(state),
  hasAlaska529Only: hasAlaska529Only(state),
  hasMaryland529Only: hasMaryland529Only(state),
  hasNational529Only: hasNational529Only(state)
});

export default connect(mapStateToProps)(LinkedBankAccountSummary);
